
// Private_Routes.js

import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import ApagarPage from '../pages/ApagarPage'
import AreceberPage from '../pages/AreceberPage'
import BancosPage from '../pages/BancosPage'
import ComprasPage from '../pages/ComprasPage'
import EmpresasPage from '../pages/EmpresasPage'
import EstoquePage from '../pages/EstoquePage'
import ClientesPage from '../pages/ClientesPage'
import FornecedoresPage from '../pages/FornecedoresPage'
import GerencialPage from '../pages/GerencialPage'
import ProducaoPage from '../pages/ProducaoPage'
import ProdutosPage from '../pages/ProdutosPage'
import RelatoriosPage from '../pages/RelatoriosPage'
import MateriaisPage from '../pages/MateriaisPage'
import VendasPage from '../pages/VendasPage'

const PrivateRoutes = () => {
  return (
      //<BrowserRouter>
        <Routes>
        <Route path="/home" element={<EmpresasPage />} />
        <Route path="/apagar" element={<ApagarPage />} />
        <Route path="/areceber" element={<AreceberPage />} />
        <Route path="/bancos" element={<BancosPage />} />
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/fornecedores" element={<FornecedoresPage />} />
        <Route path="/compras" element={<ComprasPage />} />
        <Route path="/estoque" element={<EstoquePage />} />
        <Route path="/gerencial" element={<GerencialPage />} />
        <Route path="/producao" element={<ProducaoPage />} />
        <Route path="/relatorios" element={<RelatoriosPage />} />
        <Route path="/vendas" element={<VendasPage />} />
        <Route path="/produtos" element={<ProdutosPage />} />
        <Route path="/materiais" element={<MateriaisPage />} />

        </Routes>
      //</BrowserRouter>
  )
}

export default PrivateRoutes
